import React from "react"
import { useSelector } from "react-redux"

import { StoreType } from "client/store"
import {
    Container,
    PageHeader,
    PageContent,
    PageForm,
} from "client/components"

const NotFound = () => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    return (
        <Container>
            <PageHeader>
                {lang.notFoundHeader}
            </PageHeader>
            <PageContent>
                <PageForm>
                    {lang.notFoundBody}
                </PageForm>
            </PageContent>
        </Container>
    )
}
export default NotFound
